/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import Icons from '../../assets/icons/indexSVG';
import { ReactComponent as IconAdDoctorVisit } from '../../assets/icons/icon-ad-doctor-visits.svg';
import { ReactComponent as IconAdCheckups } from '../../assets/icons/icon-ad-checkups.svg';
import { ReactComponent as IconAdBirthControl } from '../../assets/icons/icon-ad-birth-control.svg';
import { ReactComponent as IconAdInfections } from '../../assets/icons/icon-ad-infections.svg';
import { ReactComponent as IconAdWellWoman } from '../../assets/icons/icon-ad-well-woman.svg';
import { ReactComponent as IconAdSkincare } from '../../assets/icons/icon-ad-skincare.svg';
import { ReactComponent as IconSuccessDiscountCode } from '../../assets/icons/icon-success-discount-code.svg';
import { ReactComponent as IconWelcomeEmoji } from '../../assets/icons/icon-welcome-emoji.svg';
import { ReactComponent as IconUserProfileMenu } from '../../assets/icons/icon_user_profile_menu.svg';
import { ReactComponent as IconUserProfileMenuWhatsNew } from '../../assets/icons/icon_user_profile_menu_whatsnew.svg';
import { ReactComponent as IconUserProfileMenuLogout } from '../../assets/icons/icon_user_profile_menu_logout.svg';
import { ReactComponent as IconCareHistorySickVisit } from '../../assets/icons/icon_care_history_sick_visit.svg';
import { ReactComponent as IconCareHistoryBirthControlVisit } from '../../assets/icons/icon_care_history_birth_control_visit.svg';
import { ReactComponent as IconCareHistoryUTIVisit } from '../../assets/icons/icon_care_history_uti_visit.svg';
import { ReactComponent as IconCareHistorySTDDiagVisit } from '../../assets/icons/icon_care_history_std_diagnosis_visit.svg';
import { ReactComponent as IconCareHistorySTDTestVisit } from '../../assets/icons/icon_care_history_std_test_visit.svg';
import { ReactComponent as IconCareHistoryBehavioralHealthVisit } from '../../assets/icons/icon_care_history_beha_health_visit.svg';
import { ReactComponent as IconCareHistoryVaginalInfecVisit } from '../../assets/icons/icon_care_history_vag_infection_visit.svg';
import { ReactComponent as IconCareHistoryMenstraulVisit } from '../../assets/icons/icon_care_history_mens_irregularities_visit.svg';
import { ReactComponent as IconCareHistoryErectileDysVisit } from '../../assets/icons/icon_care_history_erectile_dys_visit.svg';
import { ReactComponent as IconCareHistoryHairSkinVisit } from '../../assets/icons/icon_care_history_hair_skin_visit.svg';
import { ReactComponent as IconMessageOffNotifyBadge } from '../../assets/icons/icon_message_off_notify_badge.svg';
import { ReactComponent as IconMessageOnNotifyBadge } from '../../assets/icons/icon_message_on_notify_badge.svg';
import { ReactComponent as IconWhatsNewHomepageFeature } from '../../assets/icons/icon_whatsnew_homepage_feature.svg';
import { ReactComponent as IconWhatsNewHairSkinFeature } from '../../assets/icons/icon_whatsnew_hair_skin_feature..svg';
import { ReactComponent as IconWhatsNewReproductiveFeature } from '../../assets/icons/icon_whatsnew_reproductive_care_feature.svg';
import { ReactComponent as IconProfileCameraUpload } from '../../assets/icons/icon_profile_camera_upload.svg';
import { ReactComponent as IconMessageTimestampAttached } from '../../assets/icons/icon_message_timestamp_attached.svg';
import { ReactComponent as IconCareHistoryLists } from '../../assets/icons/icon_care_history_lists.svg';
import { ReactComponent as IconChatPoint } from '../../assets/icons/icon_behavioral_upgrade_chat.svg';
import { ReactComponent as IconFreeShippingPoint } from '../../assets/icons/icon_behavioral_upgrade_free_shipping.svg';
import { ReactComponent as IconIDVerificationUpload } from '../../assets/icons/icon_id_verification_upload.svg';
import { ReactComponent as IconSelfieVerificationUpload } from '../../assets/icons/icon_selfie_verification_upload.svg';
import { ReactComponent as IconDoorstepDeliveryBox } from '../../assets/icons/icon_doorstep_delivery_box.svg';
import { ReactComponent as IconRefillPrescription } from '../../assets/icons/icon_refill_prescription.svg';
import { ReactComponent as IconClinicBuilding } from '../../assets/icons/icon_clinic_building.svg';
import { ReactComponent as IconEmailLabResult } from '../../assets/icons/icon_email_lab_result.svg';
import { ReactComponent as IconQuestLab } from '../../assets/icons/icon_quest_lab.svg';
import { ReactComponent as IconReviewLabReport } from '../../assets/icons/icon_review_lab_report.svg';
import { ReactComponent as IconInputFileUpload } from '../../assets/icons/icon_input_file_upload.svg';
import { ReactComponent as IconDiscreetMailBox } from '../../assets/icons/icon_discreet_mail_box.svg';
import { ReactComponent as IconReviewMessageFromTherapist } from '../../assets/icons/icon_review_message_from_therapist.svg';
import { ReactComponent as IconRefererProvider } from '../../assets/icons/icon_referer_provider.svg';
import { ReactComponent as IconTherapistInfoReview } from '../../assets/icons/icon_therapist_info_review.svg';
import { ReactComponent as IconSubStar } from '../../assets/icons/icon_subscription_type_premium_tag.svg';
import { ReactComponent as IconSubHeadsEmoji } from '../../assets/icons/icon_subscription_heads_emoji.svg';
import { ReactComponent as IconChatCardPrescription } from '../../assets/icons/icon_chat_card_prescription.svg';
import { ReactComponent as IconChatCardVisitPrescription } from '../../assets/icons/icon_chat_card_visit.svg';
import { ReactComponent as IconChatCardBirthControlPill } from '../../assets/icons/icon_chat_card_birth_control_pill.svg';
import { ReactComponent as IconChatCardSickVisitPill } from '../../assets/icons/icon_chat_card_sick_visit_pill.svg';
import { ReactComponent as IconChatCardUTI } from '../../assets/icons/icon_chat_card_uti.svg';
import { ReactComponent as IconChatCardMentalHealthTreatment } from '../../assets/icons/icon_chat_card_mental_health_treatment.svg';
import { ReactComponent as IconChatCardSTDDiagnosis } from '../../assets/icons/icon_chat_card_std_diagnosis.svg';
import { ReactComponent as IconChatCardSTDTest } from '../../assets/icons/icon_chat_card_std_test.svg';
import { ReactComponent as IconChatCardMenstrualIrregularities } from '../../assets/icons/icon_chat_card_menstrual_irregularities.svg';
import { ReactComponent as IconChatCardVaginalInfections } from '../../assets/icons/icon_chat_card_vaginal_infections.svg';
import { ReactComponent as IconChatCardErectileDysfunction } from '../../assets/icons/icon_chat_card_erectile_dysfunction.svg';
import { ReactComponent as IconChatCardHairSkin } from '../../assets/icons/icon_chat_card_hair_skin.svg';
import { ReactComponent as IconChatPreviewDocument } from '../../assets/icons/icon_chat_preview_document.svg';
import { ReactComponent as IconChatPreviewImage } from '../../assets/icons/icon_chat_preview_image.svg';
import { ReactComponent as IconChatPreviewSticker } from '../../assets/icons/icon_chat_preview_sticker.svg';
import { ReactComponent as IconChatPreviewVideo } from '../../assets/icons/icon_chat_preview_video.svg';
import { ReactComponent as IconChatPreviewWarning } from '../../assets/icons/icon_chat_preview_warning.svg';
import { ReactComponent as IconChatDocumentUpload } from '../../assets/icons/icon_chat_document_upload.svg';
import { ReactComponent as IconChatDocumentPreviewDownload } from '../../assets/icons/icon_chat_document_download.svg';
import { ReactComponent as IconChatCardVideoCall } from '../../assets/icons/icon_chat_card_video_call.svg';
import { ReactComponent as IconSleepEmoji } from '../../assets/icons/icon_sleep_emoji.svg';
import { ReactComponent as IconLongArrowRight } from '../../assets/icons/icon_long_arrow_right.svg';
import { ReactComponent as IconChatCardRxRefill } from '../../assets/icons/icon_chat_card_rx_refill.svg';
import { ReactComponent as IconChatCardSexualHealth } from '../../assets/icons/icon_chat_card_sexual_health.svg';
import { ReactComponent as IconExpandAndView } from '../../assets/icons/icon_expand_and_view.svg';
import { ReactComponent as IconCareNotesAttachment } from '../../assets/icons/icon_care_notes_attachment.svg';
import { ReactComponent as IconLabReportDocument } from '../../assets/icons/icon_lab_report_document.svg';
import { ReactComponent as IconChatMarkAsRead } from '../../assets/icons/icon_chat_preview_mark_as_read.svg';
import { ReactComponent as IconChatMarkAsSent } from '../../assets/icons/icon_chat_preview_mark_as_sent.svg';
import { ReactComponent as IconPatientAvatar } from '../../assets/icons/icon_patient_avatar.svg';
import { ReactComponent as IconDelete } from '../../assets/icons/icon_delete.svg';
import { ReactComponent as IconSearch } from '../../assets/icons/icon_search.svg';
import { ReactComponent as IconArrowForward } from '../../assets/icons/icon-arrow-forward.svg';
import { ReactComponent as IconPingNotification } from '../../assets/icons/icon-ping-notification.svg';
import { ReactComponent as IconSupportCareRequest } from '../../assets/icons/icon_support_care_request.svg';
import { ReactComponent as IconHamburger } from '../../assets/icons/icon_hamburger.svg';
import { ReactComponent as IconFileAttachment } from '../../assets/icons/icon_file_attachment.svg';
import { ReactComponent as IconFilter } from '../../assets/icons/icon_filter.svg';
import { ReactComponent as IconLabResult } from '../../assets/icons/icon_lab_result.svg';

type IconProps = {
  id: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
};

const allIcons: Record<string, (props: React.SVGProps<SVGSVGElement>) => JSX.Element | any> = {
  ...Icons,
  adDoctorVisit: IconAdDoctorVisit,
  adCheckups: IconAdCheckups,
  adBirthControl: IconAdBirthControl,
  adInfections: IconAdInfections,
  adWellWoman: IconAdWellWoman,
  adSkincare: IconAdSkincare,
  successDiscountCode: IconSuccessDiscountCode,
  iconWelcomeEmoji: IconWelcomeEmoji,
  iconUserProfileMenu: IconUserProfileMenu,
  iconUserProfileMenuWhatsNew: IconUserProfileMenuWhatsNew,
  iconUserProfileMenuLogout: IconUserProfileMenuLogout,
  iconCareHistorySickVisit: IconCareHistorySickVisit,
  iconCareHistoryBirthControlVisit: IconCareHistoryBirthControlVisit,
  iconCareHistoryUTIVisit: IconCareHistoryUTIVisit,
  iconCareHistorySTDDiagVisit: IconCareHistorySTDDiagVisit,
  iconCareHistorySTDTestVisit: IconCareHistorySTDTestVisit,
  iconCareHistoryBehavioralHealthVisit: IconCareHistoryBehavioralHealthVisit,
  iconCareHistoryVaginalInfecVisit: IconCareHistoryVaginalInfecVisit,
  iconCareHistoryMenstraulVisit: IconCareHistoryMenstraulVisit,
  iconCareHistoryErectileDysVisit: IconCareHistoryErectileDysVisit,
  iconCareHistoryHairSkinVisit: IconCareHistoryHairSkinVisit,
  iconMessageOffNotifyBadge: IconMessageOffNotifyBadge,
  iconMessageOnNotifyBadge: IconMessageOnNotifyBadge,
  iconWhatsNewHomepageFeature: IconWhatsNewHomepageFeature,
  iconWhatsNewHairSkinFeature: IconWhatsNewHairSkinFeature,
  iconWhatsNewReproductiveFeature: IconWhatsNewReproductiveFeature,
  iconProfileCameraUpload: IconProfileCameraUpload,
  iconMessageTimestampAttached: IconMessageTimestampAttached,
  iconCareHistoryList: IconCareHistoryLists,
  iconChatPoint: IconChatPoint,
  iconFreeShippingPoint: IconFreeShippingPoint,
  iconIDVerificationUpload: IconIDVerificationUpload,
  iconSelfieVerificationUpload: IconSelfieVerificationUpload,
  iconDoorstepDeliveryBox: IconDoorstepDeliveryBox,
  iconRefillPrescription: IconRefillPrescription,
  iconClinicBuilding: IconClinicBuilding,
  iconEmailLabResult: IconEmailLabResult,
  iconQuestLab: IconQuestLab,
  iconReviewLabReport: IconReviewLabReport,
  iconInputFileUpload: IconInputFileUpload,
  iconDiscreetMailBox: IconDiscreetMailBox,
  iconReviewMessageFromTherapist: IconReviewMessageFromTherapist,
  iconRefererProvider: IconRefererProvider,
  iconTherapistInfoReview: IconTherapistInfoReview,
  iconSubPremiumStar: IconSubStar,
  iconSubHeadsEmoji: IconSubHeadsEmoji,
  iconChatCardPrescription: IconChatCardPrescription,
  iconChatCardVisitPrescription: IconChatCardVisitPrescription,
  iconChatCardBirthControlPill: IconChatCardBirthControlPill,
  iconChatCardSickVisitPill: IconChatCardSickVisitPill,
  iconChatCardUTI: IconChatCardUTI,
  iconChatCardMentalHealthTreatment: IconChatCardMentalHealthTreatment,
  iconChatCardSTDDiagnosis: IconChatCardSTDDiagnosis,
  iconChatCardSTDTest: IconChatCardSTDTest,
  iconChatCardMenstrualIrregularities: IconChatCardMenstrualIrregularities,
  iconChatCardVaginalInfections: IconChatCardVaginalInfections,
  iconChatCardErectileDysfunction: IconChatCardErectileDysfunction,
  iconChatCardHairSkin: IconChatCardHairSkin,
  iconChatPreviewDocument: IconChatPreviewDocument,
  iconChatPreviewImage: IconChatPreviewImage,
  iconChatPreviewSticker: IconChatPreviewSticker,
  iconChatPreviewVideo: IconChatPreviewVideo,
  iconChatPreviewWarning: IconChatPreviewWarning,
  iconChatDocumentUpload: IconChatDocumentUpload,
  iconChatDocumentPreviewDownload: IconChatDocumentPreviewDownload,
  iconChatCardVideoCall: IconChatCardVideoCall,
  iconSleepEmoji: IconSleepEmoji,
  iconLongArrowRight: IconLongArrowRight,
  iconChatCardRxRefill: IconChatCardRxRefill,
  iconChatCardSexualHealth: IconChatCardSexualHealth,
  iconExpandAndView: IconExpandAndView,
  iconCareNotesAttachment: IconCareNotesAttachment,
  iconLabReportDocument: IconLabReportDocument,
  iconChatMarkAsSent: IconChatMarkAsSent,
  iconChatMarkAsRead: IconChatMarkAsRead,
  iconPatientAvatar: IconPatientAvatar,
  iconDelete: IconDelete,
  iconSearch: IconSearch,
  iconArrowForward: IconArrowForward,
  iconPingNotification: IconPingNotification,
  iconSupportCareRequest: IconSupportCareRequest,
  iconHamburger: IconHamburger,
  iconFileAttachment: IconFileAttachment,
  iconFilter: IconFilter,
  iconLabResult: IconLabResult,
};

function Icon({ id, ...rest }: IconProps) {
  const SelectedIcon = allIcons[id];
  return SelectedIcon ? <SelectedIcon id={id} {...rest} /> : null;
}

export function IconSprite({ id, ...rest }: IconProps) {
  return (
    <svg {...rest}>
      <use href={`/assets/icons/sprite.svg#${id}`} />
    </svg>
  );
}

Icon.defaultProps = {
  className: '',
  style: undefined,
  onClick: () => false,
};

export default Icon;
